import { type BoxProps, Card, Text, Title } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'

import { useStoreDetails } from '../../hooks/useStoreDetails'
import { CardStoreDetails } from '../CardStoreDetails/CardStoreDetails'

export type CardOrderContactStoreProps = BoxProps & {
  order?: CoreInquiry
}

export function CardOrderContactStore({
  order,
  ...props
}: CardOrderContactStoreProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-confirmation',
  })
  const store = useStoreDetails()

  if (!order) {
    return
  }

  return (
    <Card {...props}>
      <Title order={5}>{t('card_order_help.title')}</Title>
      <Text>{t('card_order_help.subtitle', { store: store?.name })}</Text>
      <CardStoreDetails mt='lg' />
    </Card>
  )
}
